export default "__VITE_ASSET__6de6b82e__"